export default "__VITE_ASSET__B318nXkL__"